const styles = () => ({
  line: {
    border: 'none',
    borderTop: '1px solid #e5e5e5',
    margin: '40px 0'
  }
})

export default styles
